import type { PartnerLandingAttribution } from '@/lib/partnerLandingBranding.types';

export type {
    PartnerLandingAttribution,
    PartnerLandingBranding,
    PartnerLandingLogo,
} from '@/lib/partnerLandingBranding.types';

/** UTM query keys — partner landing is gated on `utm_source=kuder`; branding uses content/term. */
export const PARTNER_LANDING_UTM_SOURCE_PARAM = 'utm_source' as const;
export const PARTNER_LANDING_UTM_CONTENT_PARAM = 'utm_content' as const;
export const PARTNER_LANDING_UTM_TERM_PARAM = 'utm_term' as const;
export const PARTNER_LANDING_UTM_EXTERNAL_SOURCE_PARAM = 'utm_external_source' as const;

/** Normalized value for `utm_source` that counts as Kuder-attributed traffic. */
export const PARTNER_LANDING_KUDER_UTM_SOURCE = 'kuder' as const;

function normalizeKeyParam(value: string | null): string | undefined {
    if (!value) {
        return undefined;
    }
    const normalizedValue = value.trim().toLowerCase().replace(/-/g, '_');
    return normalizedValue.length > 0 ? normalizedValue : undefined;
}

function isKuderUtmSource(value: string | null): boolean {
    return normalizeKeyParam(value) === PARTNER_LANDING_KUDER_UTM_SOURCE;
}

export function getPartnerLandingAttribution(search: string): PartnerLandingAttribution {
    const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
    const rawExternal = params.get(PARTNER_LANDING_UTM_EXTERNAL_SOURCE_PARAM)?.trim();
    return {
        isKuderSource: isKuderUtmSource(params.get(PARTNER_LANDING_UTM_SOURCE_PARAM)),
        partner: normalizeKeyParam(params.get(PARTNER_LANDING_UTM_CONTENT_PARAM)),
        feature: normalizeKeyParam(params.get(PARTNER_LANDING_UTM_TERM_PARAM)),
        ...(rawExternal && rawExternal.length > 0 ? { externalSourceId: rawExternal } : {}),
    };
}

export function shouldShowPartnerLanding(search: string): boolean {
    return getPartnerLandingAttribution(search).isKuderSource;
}
